// extracted by mini-css-extract-plugin
module.exports = {"info-item":"info-item_info-item_2Mg23","name":"info-item_name_2x75Q","value":"info-item_value_2LVBa"};